export default __webpack_public_path__ + "static/media/GalanoGrotesque-SemiBoldItalic.e28bf8f9.woff2";